{
  "login": {
    "welcome": "Welcome",
    "switch_to_en": "Switch to Engilsh",
    "title": "Environet - Login",
    "recover_pwd_title": "Recovering Password",
    "email": "enter your email address",
    "password": "password",
    "remember_me": "Keep me logged in",
    "forgot_password": "Forgot password?",
    "submit": "Sign In",
    "login_please": "Login please!",
    "not_authorized": "Not authorized to see this page. Log in first!",
    "already_logged_in": "Already logged in. Please log out first!",
    "logged_in": "Logged in!",
    "logged_out": "Logged out!",
    "contact_support": "Contact support",
    "copyright": "A product of Netronix Inc.",
    "password_reset_text": "The password reset information will be sent to the email address you provide.",
    "password_reset": "Reset Password",
    "powered_by": "Powered by Netronix, Inc.",
    "signup_successful": "Signup was successful, please log in."
  }
}
